import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "className", "settings", "prevBtnClassname", "nextBtnClassname", "btnClassname"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useEffect, useRef } from 'react';
import classNames from 'classnames/bind';
import { ChevronLeftIcon, ChevronRightIcon } from '@beef/ui-kit';
import { Carousel } from "../index";
import baseStyle from "../../../styles/base.module.pcss";
import style from "./styles.module.pcss";
var cn = classNames.bind(_objectSpread(_objectSpread({}, style), baseStyle));
var CarouselWithNavigation = function CarouselWithNavigation(_ref) {
  var children = _ref.children,
    className = _ref.className,
    settings = _ref.settings,
    prevBtnClassname = _ref.prevBtnClassname,
    nextBtnClassname = _ref.nextBtnClassname,
    btnClassname = _ref.btnClassname,
    props = _objectWithoutProperties(_ref, _excluded);
  var prevCarouselBtn = useRef(null);
  var nextCarouselBtn = useRef(null);
  var swiperRef = useRef(null);
  useEffect(function () {
    if (swiperRef.current && prevCarouselBtn.current && nextCarouselBtn.current) {
      var navigationParams = swiperRef.current.params.navigation;
      navigationParams.prevEl = prevCarouselBtn.current;
      navigationParams.nextEl = nextCarouselBtn.current;
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, [prevCarouselBtn.current, nextCarouselBtn.current, swiperRef]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrap')
  }, /*#__PURE__*/React.createElement("button", {
    className: cn('btn', 'btn-wrap', 'btn-wrap--prev', btnClassname, prevBtnClassname),
    ref: prevCarouselBtn,
    type: "button"
  }, /*#__PURE__*/React.createElement("span", {
    className: cn('sr-only')
  }, "\u041D\u0430\u0437\u0430\u0434"), /*#__PURE__*/React.createElement(ChevronLeftIcon, null)), /*#__PURE__*/React.createElement("button", {
    className: cn('btn', 'btn-wrap', 'btn-wrap--next', btnClassname, nextBtnClassname),
    ref: nextCarouselBtn,
    type: "button"
  }, /*#__PURE__*/React.createElement("span", {
    className: cn('sr-only')
  }, "\u0412\u043F\u0435\u0440\u0435\u0434"), /*#__PURE__*/React.createElement(ChevronRightIcon, null)), /*#__PURE__*/React.createElement(Carousel, _extends({
    settings: _objectSpread(_objectSpread({}, settings), {}, {
      onInit: function onInit(swiperInstance) {
        swiperRef.current = swiperInstance;
        if (settings !== null && settings !== void 0 && settings.onInit) {
          settings.onInit(swiperInstance);
        }
      }
    })
  }, props, {
    className: className
  }), children));
};
export { CarouselWithNavigation };